import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.scenario');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-scenario',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.scenario/view.scss */
:host {
  display: block;
  height: 100%;
}

.scenario-flow-arrow {
  position: relative;
}
.scenario-flow-arrow::after {
  content: "";
  position: absolute;
  right: -18px;
  top: 50%;
  transform: translateY(-50%);
  border-left: 8px solid #cbd5e1;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
}
.scenario-flow-arrow:last-child::after {
  display: none;
}

.timeline-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 3px solid;
  background: white;
  z-index: 1;
}

.note-area {
  min-height: 80px;
  field-sizing: content;
}

.discussion-card {
  transition: box-shadow 0.15s ease;
}
.discussion-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}`],
})
export class PageScenarioComponent implements OnInit {
    public activeSection: string = 'overview';
    public expandedSteps: any = {};
    public saving: boolean = false;
    public lastSaved: string = '';
    public flowMemo: string = '';
    public discussionMemo: string = '';

    public sections: any[] = [
        { id: 'overview', label: '전체 개요', icon: 'fa-solid fa-map' },
        { id: 'flow', label: '진료 흐름도', icon: 'fa-solid fa-diagram-project' },
        { id: 'scenarios', label: '단계별 시나리오', icon: 'fa-solid fa-list-check' },
        { id: 'consultation', label: '문진 시나리오', icon: 'fa-solid fa-user-doctor' },
        { id: 'discussion', label: '논의 사항', icon: 'fa-solid fa-comments' },
    ];

    public scenarios: any[] = [
        {
            id: 'S1',
            phase: '접수',
            title: '환자 내원 및 접수',
            icon: 'fa-solid fa-clipboard-check',
            color: 'blue',
            current: [
                '환자 이름/전화번호로 검색하여 기존 환자 확인',
                '신규 환자: 간편 등록(이름, 생년월일, 성별, 전화번호) 후 접수',
                '재진 환자: 기존 정보 자동 로드 후 접수',
                '담당의 지정, 진료 유형(초진/재진/응급) 선택',
                '내원 메모 작성 가능',
            ],
            questions: [
                '접수 시 보험 유형(건강보험/비급여/자보 등) 확인 절차는?',
                '초진 환자에게 사전 문진표를 작성하게 하는가?',
                '예약 환자와 당일 접수의 구분이 필요한가?',
                '접수 시 증상 카테고리(내과/침구/추나 등) 사전 분류가 필요한가?',
            ],
            notes: '',
        },
        {
            id: 'S2',
            phase: '대기',
            title: '대기 관리 및 호출',
            icon: 'fa-solid fa-clock',
            color: 'amber',
            current: [
                '접수 후 대기열에 자동 추가 (상태: 대기)',
                '대시보드에서 실시간 대기 현황 조회 (30초 갱신)',
                '대기 시간 15분 초과 시 주황색, 30분 초과 시 빨간색 경고',
                '진료 시작 버튼으로 상태 전환 (대기 → 진료중)',
            ],
            questions: [
                '대기 순서 변경(우선순위 조정)이 필요한 경우가 있는가?',
                '진료실이 여러 개인 경우 진료실별 대기 관리가 필요한가?',
                '환자 호출 알림(전광판, SMS 등)은 어떤 방식으로 하는가?',
                '대기 중 사전 검사(혈압, 체온 등) 기록이 필요한가?',
            ],
            notes: '',
        },
        {
            id: 'S3',
            phase: '문진',
            title: '문진 및 주소증 파악',
            icon: 'fa-solid fa-stethoscope',
            color: 'indigo',
            current: [
                '주소증(Chief Complaint) 텍스트 입력',
                '현병력(History of Present Illness) 기록',
                '과거력·가족력 확인',
                'KCD 진단코드 검색 및 선택 (최대 5개)',
                'AI 어시스턴트를 통한 문진 가이드 제공',
            ],
            questions: [
                '한의학 특유의 문진 항목(수면, 소화, 대소변, 식욕, 한열 등)의 구조화된 입력이 필요한가?',
                '사상체질 문진표 등 표준화된 설문이 통합되어야 하는가?',
                '문진 시 환자의 과거 진료 이력 요약이 자동으로 표시되어야 하는가?',
                '주소증 입력 시 자주 사용하는 표현의 자동완성이 있으면 좋겠는가?',
            ],
            notes: '',
        },
        {
            id: 'S4',
            phase: '진찰',
            title: '사진(四診) - 객관적 소견',
            icon: 'fa-solid fa-hand-holding-medical',
            color: 'violet',
            current: [
                '인체 통증 지도(Body Map): 전면/후면에서 부위별 증상 선택',
                '설진(舌診): 혀 색상, 설태, 설형 시각적 선택 입력',
                '맥진(脈診): 부침, 지삭, 맥형 등 선택식 입력',
                '복진(腹診): 메모 기반 기록',
            ],
            questions: [
                '망진(望診) - 안색, 체형, 보행 상태 등의 기록 항목이 필요한가?',
                '문진(聞診) - 음성, 호흡 소리, 체취 등의 기록이 필요한가?',
                '맥진 데이터의 좌/우 손 구분이 필요한가? (촌관척 각각)',
                '설진 사진 촬영 및 저장 기능이 필요한가?',
                '복진에서 압통점의 위치를 시각적으로 표시하는 기능이 필요한가?',
                '체온, 혈압, 맥박 등 바이탈 사인 입력 섹션이 필요한가?',
            ],
            notes: '',
        },
        {
            id: 'S5',
            phase: '진단',
            title: '변증 및 진단',
            icon: 'fa-solid fa-brain',
            color: 'rose',
            current: [
                '변증(辨證): 사상체질, 팔강변증 등 텍스트 기반 입력',
                '치료 원칙 및 치료 계획 수립',
                'AI 진단 보조: 입력된 증상 기반 변증 제안',
            ],
            questions: [
                '주로 사용하는 변증 체계는? (팔강, 장부, 기혈진액, 육경, 위기영혈 등)',
                '사상체질 판별이 진단 과정에서 어느 시점에 이루어지는가?',
                '양·한방 협진 시 KCD 코드 외에 별도 한의 진단 분류 체계가 필요한가?',
                'AI 변증 제안의 신뢰도 표시가 필요한가?',
                '감별 진단(differential diagnosis)을 기록하는 구조가 필요한가?',
            ],
            notes: '',
        },
        {
            id: 'S6',
            phase: '처방',
            title: '처방 및 치료 계획',
            icon: 'fa-solid fa-prescription',
            color: 'emerald',
            current: [
                '한약 처방: 약재 검색, 군신좌사 역할 지정, 용량/단위 설정',
                '침구 처방: 경혈 검색, 좌/우/양측 선택',
                '처방 유형: 한약, 침, 부항, 뜸 등 구분',
                '복약 지도(투약 안내) 텍스트 작성',
                'AI 처방 추천 기능',
            ],
            questions: [
                '자주 사용하는 처방(빈용 처방)의 템플릿 기능이 필요한가?',
                '한약 처방 시 일수(투약일수)와 복용 횟수 입력은?',
                '첩수(貼數) 관리는 어떻게 하는가?',
                '약재 간 상호작용(배오금기) 경고가 필요한가?',
                '침구 시술 시 자극 방법(보사법, 유침 시간 등) 기록이 필요한가?',
                '추나, 부항, 뜸 등 비약물 치료의 상세 기록 항목은?',
                '처방전 출력/인쇄 형식은 어떠해야 하는가?',
            ],
            notes: '',
        },
        {
            id: 'S7',
            phase: '수납·마무리',
            title: '수납 및 진료 완료',
            icon: 'fa-solid fa-receipt',
            color: 'teal',
            current: [
                '차트 확정(최종) 후 대기열 상태 → 완료',
                '처방 이력에 자동 저장',
                '별도 수납 프로세스는 현재 미구현',
            ],
            questions: [
                '수납(결제) 프로세스의 통합이 필요한가?',
                '다음 예약 일정 등록 기능은?',
                '진료 요약서/소견서 자동 생성이 필요한가?',
                '환자에게 처방 내용 SMS/카카오 알림 발송이 필요한가?',
                '진료비 계산(보험/비보험 구분)은 어떻게 처리하는가?',
            ],
            notes: '',
        },
        {
            id: 'S8',
            phase: '관리',
            title: '데이터 관리 및 통계',
            icon: 'fa-solid fa-chart-bar',
            color: 'sky',
            current: [
                '환자 목록 관리 (기본 정보, 병력, 진료 이력 조회)',
                '처방 이력 통합 조회 및 필터링',
                '관리자: 본초/방제, 경혈, 진단코드 마스터 데이터 관리',
                'AI 프롬프트 설정 관리',
                '사용자(의료진) 계정 및 권한 관리',
            ],
            questions: [
                '진료 통계(일별/월별 환자 수, 진료 유형 등) 리포트가 필요한가?',
                '약재 재고 관리와 연동이 필요한가?',
                '처방 빈도 분석(자주 사용하는 약재/경혈) 통계가 필요한가?',
                '환자별 치료 경과 추적(회차별 개선 추이)이 필요한가?',
                '데이터 백업/내보내기 기능이 필요한가?',
            ],
            notes: '',
        },
    ];

    public consultationSteps: any[] = [
        {
            id: 'C1',
            phase: '인사·접근',
            title: '환자 맞이 및 라포 형성',
            icon: 'fa-solid fa-handshake',
            color: 'blue',
            draft: [
                '환자 이름/차트 확인, 인사',
                '초진/재진 여부 확인',
                '오늘 내원 이유(주소증) 개방형 질문',
            ],
            realFlow: '',
        },
        {
            id: 'C2',
            phase: '주소증 파악',
            title: '주소증 및 현병력 청취',
            icon: 'fa-solid fa-ear-listen',
            color: 'indigo',
            draft: [
                '언제부터 증상이 시작되었는가?',
                '어디가 어떻게 아픈가? (부위, 양상, 강도)',
                '악화/완화 요인은?',
                '이전 치료 경험 및 효과는?',
            ],
            realFlow: '',
        },
        {
            id: 'C3',
            phase: '한의 문진',
            title: '십문가(十問歌) 기반 전신 문진',
            icon: 'fa-solid fa-clipboard-list',
            color: 'violet',
            draft: [
                '한열(寒熱): 추위/더위 민감도, 발열 여부',
                '한출(汗出): 자한/도한 여부, 발한 부위',
                '음식(飮食): 식욕, 소화, 음수량, 선호 음식 온도',
                '대소변: 빈도, 양상, 색상이상',
                '수면: 입면, 중도각성, 꿈, 수면 질',
                '두통/어지럼: 유형, 빈도',
                '흉복부: 심계, 흉민, 복통, 복만',
                '여성: 월경주기, 량, 통증, 대하',
                '정서: 스트레스, 우울, 불안 수준',
                '기력: 피로도, 기력 저하 시간대',
            ],
            realFlow: '',
        },
        {
            id: 'C4',
            phase: '망진',
            title: '망진(望診) - 시각적 관찰',
            icon: 'fa-solid fa-eye',
            color: 'amber',
            draft: [
                '안색·광택: 창백, 위황, 홍조 등',
                '체형·자세: 비만/수척, 부종, 보행 상태',
                '설진(舌診): 설체(색·형·동태), 설태(색·질·분포)',
                '피부 상태: 발진, 건조, 부종 부위',
            ],
            realFlow: '',
        },
        {
            id: 'C5',
            phase: '문진(聞)',
            title: '문진(聞診) - 청각·후각 관찰',
            icon: 'fa-solid fa-volume-high',
            color: 'rose',
            draft: [
                '음성: 크기, 맑음/탁함',
                '호흡: 깊이, 빈도, 천식음',
                '기침: 유무, 양상, 가래',
                '체취·구취 확인',
            ],
            realFlow: '',
        },
        {
            id: 'C6',
            phase: '맥진·촉진',
            title: '절진(切診) - 맥진 및 복진',
            icon: 'fa-solid fa-hand-dots',
            color: 'emerald',
            draft: [
                '맥진: 좌우 촌관척 각각 촉지',
                '맥상 판별: 부/침, 지/삭, 허/실, 활/삽 등',
                '복진: 복부 압통점, 긴장도, 냉열 확인',
                '경혈 압통 반응점 확인',
            ],
            realFlow: '',
        },
        {
            id: 'C7',
            phase: '변증·설명',
            title: '진단 설명 및 치료 계획 동의',
            icon: 'fa-solid fa-comments',
            color: 'teal',
            draft: [
                '환자에게 진단 결과(변증) 쉽게 설명',
                '치료 방법(침, 한약, 추나 등) 설명 및 동의',
                '치료 횟수·기간 안내',
                '주의사항·생활 지도 안내',
            ],
            realFlow: '',
        },
        {
            id: 'C8',
            phase: '시술·처방',
            title: '시술 시행 및 처방 발행',
            icon: 'fa-solid fa-syringe',
            color: 'sky',
            draft: [
                '침 시술: 선혈, 자침, 유침, 발침',
                '부항/뜸/추나 등 부가 시술',
                '한약 처방전 작성 및 복약 지도',
                '다음 예약 안내',
            ],
            realFlow: '',
        },
    ];

    public discussionTopics: any[] = [
        {
            category: '진료 프로세스',
            icon: 'fa-solid fa-arrows-spin',
            topics: [
                '실제 한의원의 하루 진료 흐름은 현재 시스템과 어떻게 다른가?',
                '접수부터 퇴원까지 각 단계에서 소요되는 시간은?',
                '동시에 진료하는 환자 수와 의료진 구성은?',
                '재진 환자의 진료 흐름은 초진과 어떻게 다른가?',
            ],
            notes: '',
        },
        {
            category: '한의학 전문 용어 및 분류 체계',
            icon: 'fa-solid fa-book-medical',
            topics: [
                '시스템에서 사용해야 하는 표준 용어 체계는?',
                '변증 분류 체계의 우선순위와 사용 빈도는?',
                '약재 분류(성미귀경 등)의 표시 방법은?',
                '경혈 분류 및 표시 방법의 개선점은?',
            ],
            notes: '',
        },
        {
            category: 'AI 어시스턴트',
            icon: 'fa-solid fa-robot',
            topics: [
                'AI가 가장 도움이 될 수 있는 진료 단계는?',
                'AI 진단/처방 제안의 신뢰도 기준은?',
                'AI가 참고해야 할 한의학 문헌/데이터는?',
                'AI 사용 시 주의해야 할 법적/윤리적 사항은?',
            ],
            notes: '',
        },
        {
            category: '특수 상황',
            icon: 'fa-solid fa-triangle-exclamation',
            topics: [
                '응급 상황 발생 시 시스템 대응은?',
                '소아/노인 환자의 특수 진료 흐름은?',
                '양·한방 협진 시 데이터 공유 방식은?',
                '원격 진료(비대면) 시나리오의 필요성은?',
            ],
            notes: '',
        },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.scenarios.forEach(s => this.expandedSteps[s.id] = true);
        this.consultationSteps.forEach(s => this.expandedSteps[s.id] = true);
        await this.loadMemos();
        await this.service.render();
    }

    public setSection(id: string) {
        this.activeSection = id;
        this.service.render();
    }

    public toggleStep(id: string) {
        this.expandedSteps[id] = !this.expandedSteps[id];
        this.service.render();
    }

    public async loadMemos() {
        const { code, data } = await wiz.call('load');
        if (code === 200 && data) {
            this.flowMemo = data.flowMemo || '';
            this.discussionMemo = data.discussionMemo || '';
            if (data.scenarioNotes) {
                for (const s of this.scenarios) {
                    if (data.scenarioNotes[s.id]) s.notes = data.scenarioNotes[s.id];
                }
            }
            if (data.consultationNotes) {
                for (const c of this.consultationSteps) {
                    if (data.consultationNotes[c.id]) c.realFlow = data.consultationNotes[c.id];
                }
            }
            if (data.discussionNotes) {
                for (const d of this.discussionTopics) {
                    if (data.discussionNotes[d.category]) d.notes = data.discussionNotes[d.category];
                }
            }
            this.lastSaved = data._lastSaved || '';
        }
    }

    public async saveMemos() {
        this.saving = true;
        await this.service.render();

        const scenarioNotes: any = {};
        for (const s of this.scenarios) {
            if (s.notes) scenarioNotes[s.id] = s.notes;
        }
        const consultationNotes: any = {};
        for (const c of this.consultationSteps) {
            if (c.realFlow) consultationNotes[c.id] = c.realFlow;
        }
        const discussionNotes: any = {};
        for (const d of this.discussionTopics) {
            if (d.notes) discussionNotes[d.category] = d.notes;
        }

        const now = new Date();
        const ts = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

        const payload = {
            flowMemo: this.flowMemo,
            discussionMemo: this.discussionMemo,
            scenarioNotes,
            consultationNotes,
            discussionNotes,
            _lastSaved: ts,
        };

        try {
            const { code } = await wiz.call('save', { data: JSON.stringify(payload) });
            if (code === 200) {
                this.lastSaved = ts;
            }
        } catch (e) {
        }

        this.saving = false;
        await this.service.render();
    }

    public getColorClass(color: string, type: string) {
        const map: any = {
            'blue': { bg: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-700', icon: 'bg-blue-100 text-blue-600', badge: 'bg-blue-100 text-blue-700', line: 'bg-blue-300' },
            'amber': { bg: 'bg-amber-50', border: 'border-amber-200', text: 'text-amber-700', icon: 'bg-amber-100 text-amber-600', badge: 'bg-amber-100 text-amber-700', line: 'bg-amber-300' },
            'indigo': { bg: 'bg-indigo-50', border: 'border-indigo-200', text: 'text-indigo-700', icon: 'bg-indigo-100 text-indigo-600', badge: 'bg-indigo-100 text-indigo-700', line: 'bg-indigo-300' },
            'violet': { bg: 'bg-violet-50', border: 'border-violet-200', text: 'text-violet-700', icon: 'bg-violet-100 text-violet-600', badge: 'bg-violet-100 text-violet-700', line: 'bg-violet-300' },
            'rose': { bg: 'bg-rose-50', border: 'border-rose-200', text: 'text-rose-700', icon: 'bg-rose-100 text-rose-600', badge: 'bg-rose-100 text-rose-700', line: 'bg-rose-300' },
            'emerald': { bg: 'bg-emerald-50', border: 'border-emerald-200', text: 'text-emerald-700', icon: 'bg-emerald-100 text-emerald-600', badge: 'bg-emerald-100 text-emerald-700', line: 'bg-emerald-300' },
            'teal': { bg: 'bg-teal-50', border: 'border-teal-200', text: 'text-teal-700', icon: 'bg-teal-100 text-teal-600', badge: 'bg-teal-100 text-teal-700', line: 'bg-teal-300' },
            'sky': { bg: 'bg-sky-50', border: 'border-sky-200', text: 'text-sky-700', icon: 'bg-sky-100 text-sky-600', badge: 'bg-sky-100 text-sky-700', line: 'bg-sky-300' },
        };
        return map[color]?.[type] || '';
    }
}

export default PageScenarioComponent;